<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


$(document).ready(function(){    
    var contentHeight = $('.tabs-contents-horizontal .tab-content:first-child').outerHeight();    
      if ( contentHeight > 100) {    
        $( ".tabs-contents-horizontal .tab-content:first-child .tab-showMore" ).css( "display", "block" );    
      };
});
   